<template>
    <component :is="component" :data="data" v-if="component" />
</template>
<script>
export default {
    name: 'dynamic-link',
    props: ['data', 'type'],
    data() {
        return {
            component: null,
        }
    },
    computed: {
        loader(){
            if (!this.type) {
                return null
            }
            return () => import(`./${this.type}`)
        },
    },
    mounted() {
        if(this.loader)
            this.loader()
                .then(() => {
                    this.component = () => this.loader()
                })
                .catch(error => {
                    this.component = () => import('./confirmWindow')
                })
    },
}
</script>